import { Injector } from "@angular/core";
import { createCustomElement } from "@angular/elements";

//Third party
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MaterialModule } from "./material.module";
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from "@angular-material-components/datetime-picker";
import { ColorPickerModule } from "ngx-color-picker";

import { GridsterModule } from "angular-gridster2";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from "primeng/calendar";

//Our Modules
import { PagesModule } from "./pages/pages.module";
import { PipesModule } from "./pipes/pipes.module";
import { ComponentsModule } from "./components/components.module";
import { DirectivesModule } from "./directives/directives.module";

//Providers

//Route Pages

import { DashboardStandard1Component } from "./pages/DashboardStandard1/dashboardstandard1.component";
import { MissedCallsReportComponent } from "./pages/MissedCallsReport/missed-calls-report.component";
import { CustomisableReportsComponent } from "./pages/CustomisableReports/customisablereports.component";
import { ListPageComponent } from "./pages/ListPage/listpage.component";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatPaginatorIntlLabels } from "./components/GraphQL/StackedBarChartPagination/stackedbarchartpagination.component";

import { DataSourceService } from "./services/DataSourceServices/DataSourceService.service";
import { EveMultiDataSourceService } from "./services/DataSourceServices/EveMultiDataSourceService.service";
import { EveSingleDataSourceService } from "./services/DataSourceServices/EveSingleDataSourceService.service";
import { ControlWidgetService } from "./services/ControlWidgetService.service";
import { GraphQlService } from "./services/GraphQl/GraphQL.service";
import { IGraphQlService } from "./services/GraphQl/IGraphQL.service";
import { IDataSourceService } from "./services/DataSourceServices/IDataSourceService.service";
import { IVisibilityStateService } from "./services/VisibilityState/IVisibilityState.service";
import { VisibilityStateService } from "./services/VisibilityState/VisibilityState.service";
import { GlobalFiltersOptionalService } from "./services/DataSourceServices/GlobalFiltersOptionalService.service";
import { WebComponentOverlayContainer } from "./services/WebComponentOverlayContainer/WebComponentOverlayContainer.service";
import { OverlayContainer } from "@angular/cdk/overlay";
import { InterceptorsModule } from "./interceptors/interceptors.module";
import { EveReportingUrl } from "./interceptors/export-cons";
import { EveNotFoundComponent } from "./not-found/eve-not-found.component";

const eveReportingUrl =
  document
    .getElementsByTagName("eve-reporting-url")[0]
    ?.attributes?.getNamedItem("value")?.value ?? "";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    //     RouterModule.forRoot([{
    //       path: '**',
    //       component: EveNotFoundComponent
    //     }]
    // ),
    HttpClientModule,
    FormsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    GridsterModule,
    AutoCompleteModule,
    CalendarModule,

    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    DirectivesModule,
    ColorPickerModule,
    PagesModule,

    RouterModule.forRoot([
      //{ path: '', component: Test1Component, pathMatch: 'full' },
      {
        path: "Report/CallReports",
        component: DashboardStandard1Component,
        pathMatch: "full",
      },
      {
        path: ":guid/Report/CallReports",
        component: DashboardStandard1Component,
        pathMatch: "full",
      },
      {
        path: "Report/CallReports/DashboardStandard1",
        component: DashboardStandard1Component,
      },
      {
        path: ":guid/Report/CallReports/DashboardStandard1",
        component: DashboardStandard1Component,
      },
       {
        path: "Report/CallReports/MissedCallsReport",
        component: MissedCallsReportComponent,
      },
      {
        path: ":guid/Report/CallReports/MissedCallsReport",
        component: MissedCallsReportComponent,
      },
      {
        path: "Report/CallReports/CustomisableReports/:id",
        component: CustomisableReportsComponent,
      },
      {
        path: ":guid/Report/CallReports/CustomisableReports/:id",
        component: CustomisableReportsComponent,
      },
      {
        path: "Report/CallReports/CustomisableReports",
        component: CustomisableReportsComponent,
      },
      {
        path: ":guid/Report/CallReports/CustomisableReports",
        component: CustomisableReportsComponent,
      },
      { path: "Report/CallReports/ListPage", component: ListPageComponent },
      { path: ":guid/Report/CallReports/ListPage", component: ListPageComponent },
      {
        path: "**",
        component: EveNotFoundComponent,
      },
    ]),

    InterceptorsModule,
    ComponentsModule,
  ],
  providers: [
    { provide: EveReportingUrl, useValue: eveReportingUrl },
    { provide: IGraphQlService, useClass: GraphQlService },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    { provide: IDataSourceService, useClass: DataSourceService },
    EveMultiDataSourceService,
    EveSingleDataSourceService,
    GlobalFiltersOptionalService,
    { provide: ControlWidgetService, useValue: new ControlWidgetService() },

    { provide: IVisibilityStateService, useClass: VisibilityStateService },
    {
      provide: OverlayContainer,
      useClass: WebComponentOverlayContainer,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {}
  ngDoBootstrap() {}
}
